import React from "react";
import Image from "components/image";
import RichText from "components/rich-text";
import Button from "components/button";
import { isMobile } from "utils/device-detect";
import clsx from "clsx/lite";

const SingleImageText = ({ data }) => {
	const { content, image, cta, alternate, mobileSettings, fullWidthImage, video, mobileVideo, mobileImage } = data;

	const containerClasses = clsx(
		"flex flex-col hd-screen-max-width justify-between md:px-10 lg:px-20 p-5 items-center",
		alternate ? "md:flex-row-reverse gap-5" : "md:flex-row gap-5",
		mobileSettings?.imageBelowText ? "flex-col" : "flex-col-reverse"
	);

	const mobileView = isMobile();
	const img = (mobileView && mobileImage) ? mobileImage : image;
	const responsiveVideo = (mobileView && mobileVideo) ? mobileVideo : video;

	return (
		<div>
			<div className={containerClasses}>
				<div className="w-full lg:max-w-[544px] lg:w-[48%]">
					<RichText value={content} />
				</div>
				{responsiveVideo ?
					<video className="w-full lg:max-w-[600px] lg:w-[48%]"
						{...responsiveVideo} autoPlay={responsiveVideo.autoplay} loop={true} muted
					>
						<source src={responsiveVideo?.src} type="video/mp4" />
						Your browser does not support HTML5 video.
					</video> :
					<div className={clsx("w-full lg:max-w-[600px] lg:w-[48%]", fullWidthImage && mobileView && "w-full-image -mx-5")}>
						<Image image={img} alt={img?.alt} className="mb-5 lg:mb-0 opacity-1" />
					</div>}
			</div>
			<Button data={cta} />
		</div>
	);
};

export default SingleImageText;
